import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

interface CasinoGameCardSkeletonProps {
	className?: string
}

export function CasinoGameCardSkeleton({ className }: CasinoGameCardSkeletonProps) {
	return <Skeleton className={cn('h-[200px] w-[150px] shrink-0 rounded-2xl', className)} />
}
